// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
class _RulesSet {
    constructor() {
        this.ALLOWED = '1';
        this.NOT_ALLOWED = '0';
        this.ALLOWED_FOR_ALL = '$ALL$';
        // #region Rules constants
        this.FUNCTION_SHOW_TIME_FOR_GTD = 'FUNCTION_SHOW_TIME_FOR_GTD';
        this.VISIBILITY_INSTRUMENT_TYPE = 'VISIBILITY_INSTRUMENT_TYPE';
        this.VISIBILITY_ROUTE = 'VISIBILITY_ROUTE';
        this.FUNCTION_INSTRUMENT_PORTFOLIO = 'FUNCTION_INSTRUMENT_PORTFOLIO';
        this.FUNCTION_ORDER_BOOK = 'FUNCTION_ORDER_BOOK';
        this.FUNCTION_LEVEL2 = 'FUNCTION_LEVEL2';
        this.FUNCTION_SUPER_DOM = 'FUNCTION_SUPER_DOM'; // Tv Trading Platform
        this.FUNCTION_SCALPER = 'FUNCTION_SCALPER';
        this.FUNCTION_OE2014 = 'FUNCTION_OE2014';
        this.FUNCTION_CHART = 'FUNCTION_CHART';
        this.FUNCTION_CHAT = 'FUNCTION_CHAT';
        this.FUNCTION_NEWS = 'FUNCTION_NEWS';
        // public readonly FUNCTION_RISK_CALCULATOR = "FUNCTION_RISK_CALCULATOR"; // TODO CHECK SERVER NAME
        this.FUNCTION_SHOW_ORDERS = 'FUNCTION_SHOW_ORDERS';
        this.FUNCTION_SHOW_POSITIONS = 'FUNCTION_SHOW_POSITIONS';
        this.FUNCTION_ASSETS = 'FUNCTION_ASSETS';
        this.FUNCTION_ALERT = 'FUNCTION_ALERT';
        this.FUNCTION_ALERTS_EMAIL = 'FUNCTION_ALERTS_EMAIL';
        this.FUNCTION_ALERTS_PUSH = 'FUNCTION_ALERTS_PUSH';
        this.FUNCTION_ALERTS_PLACE_ORDER = 'FUNCTION_ALERTS_PLACE_ORDER';
        this.VALUE_TOTAL_MAX_ALERTS = 'VALUE_TOTAL_MAX_ALERTS';
        this.FUNCTION_ACCOUNTS = 'FUNCTION_ACCOUNTS';
        this.FUNCTION_ACCOUNTPERFOMANCE = 'FUNCTION_ACCOUNTPERFOMANCE';
        this.FUNCTION_WATCHLIST = 'FUNCTION_WATCHLIST';
        this.FUNCTION_LEVEL3 = 'FUNCTION_LEVEL3';
        this.FUNCTION_MATRIX = 'FUNCTION_MATRIX';
        this.FUNCTION_EVENT_LOG = 'FUNCTION_EVENT_LOG';
        this.FUNCTION_POSITION_BALANCE = 'FUNCTION_POSITION_BALANCE';
        this.FUNCTION_CUR_EXP = 'FUNCTION_CUR_EXP';
        this.FUNCTION_BUILDER = 'FUNCTION_BUILDER';
        this.FUNCTION_BASKET = 'FUNCTION_BASKET';
        this.FUNCTION_SCRIPT_BUILDER = 'FUNCTION_SCRIPT_BUILDER';
        this.FUNCTION_SYMBOL_INFO = 'FUNCTION_SYMBOL_INFO';
        this.FUNCTION_GRID = 'FUNCTION_GRID';
        this.FUNCTION_OPTION_TRADER = 'FUNCTION_OPTION_TRADER';
        this.FUNCTION_OPTION_TRADER_ANALYZER = 'FUNCTION_OPTION_TRADER_ANALYZER';
        this.FUNCTION_OPTION_TRADER_VOLATILITY_LAB = 'FUNCTION_OPTION_TRADER_VOLATILITY_LAB';
        this.FUNCTION_OPTION_TRADER_POSITIONS = 'FUNCTION_OPTION_TRADER_POSITIONS';
        this.FUNCTION_OPTION_TRADER_WORKING_ORDERS = 'FUNCTION_OPTION_TRADER_WORKING_ORDERS';
        this.FUNCTION_OPTION_TRADER_TEST_ON_PAPER = 'FUNCTION_OPTION_TRADER_TEST_ON_PAPER';
        this.FUNCTION_OPTION_TRADER_STRATEGIES = 'FUNCTION_OPTION_TRADER_STRATEGIES';
        this.FUNCTION_MARGIN_INFO = 'FUNCTION_MARGIN_INFO';
        this.FUNCTION_HEATMAP = 'FUNCTION_HEATMAP';
        this.SELF_TRADING = 'SELF_TRADING';
        this.FUNCTION_TRADING = 'FUNCTION_TRADING';
        this.FUNCTION_TRADING_CENTRAL = 'FUNCTION_TRADING_CENTRAL';
        this.FUNCTION_REPORT = 'FUNCTION_REPORT';
        this.FUNCTION_PRODUCTS = 'FUNCTION_PRODUCTS';
        this.FUNCTION_MUTUAL_CLOSE = 'FUNCTION_MUTUAL_CLOSE';
        this.FUNCTION_PARTIAL_CLOSE = 'FUNCTION_PARTIAL_CLOSE';
        this.FUNCTION_SLTP = 'FUNCTION_SLTP';
        this.FUNCTION_TRAILING_STOP = 'FUNCTION_TRAILING_STOP';
        this.FUNCTION_BINDEDORDERS = 'FUNCTION_BINDEDORDERS';
        this.FUNCTION_TRADES = 'FUNCTION_TRADES';
        this.FUNCTION_MODIFY_ORDERTYPE = 'FUNCTION_MODIFY_ORDERTYPE';
        this.FUNCTION_MODIFY_AMOUNT = 'FUNCTION_MODIFY_AMOUNT';
        this.FUNCTION_MODIFY_PRICE = 'FUNCTION_MODIFY_PRICE';
        this.FUNCTION_AUTO_POPULATE_WATCHLIST = 'FUNCTION_AUTO_POPULATE_WATCHLIST';
        this.FUNCTION_ADVANCED_OCO_MODE = 'FUNCTION_ADVANCED_OCO_MODE';
        this.FUNCTION_TRAILING_SLTP_INOFFSET = 'FUNCTION_TRAILING_SLTP_INOFFSET';
        this.FUNCTION_DONT_USE_ROUTE_SETTING_FOR_CLOSE_TS_ORDER = 'FUNCTION_DONT_USE_ROUTE_SETTING_FOR_CLOSE_TS_ORDER';
        this.FUNCTION_UPDATE_TRAILING_STOP_ON_NEWQUOTE = 'FUNCTION_UPDATE_TRAILING_STOP_ON_NEWQUOTE';
        this.FUNCTION_USE_ONE_ROUTE = 'FUNCTION_USE_ONE_ROUTE';
        this.FUNCTION_BASE_CURRENCY = 'FUNCTION_BASE_CURRENCY';
        this.FUNCTION_ALLOW_ORDERS_HISTORY = 'FUNCTION_ALLOW_ORDERS_HISTORY';
        this.FUNCTION_ALLOW_TRADES_HISTORY = 'FUNCTION_ALLOW_TRADES_HISTORY';
        this.VALUE_EXPOSITION_IN_IMSTRUMENT_CURRENCY = 'VALUE_EXPOSITION_IN_IMSTRUMENT_CURRENCY';
        this.FUNCTION_NON_FIXED_LIST = 'FUNCTION_NON_FIXED_LIST';
        this.VALUE_THROTLING_PANEL_LIMIT_AGGRESSOR_BALANCE = 'VALUE_THROTLING_PANEL_LIMIT_AGGRESSOR_BALANCE_COUNT';
        this.VALUE_THROTLING_PANEL_LIMIT_CHART_COUNT = 'VALUE_THROTLING_PANEL_LIMIT_CHART_COUNT';
        this.VALUE_THROTLING_PANEL_LIMIT_MARKETDEPTH_COUNT = 'VALUE_THROTLING_PANEL_LIMIT_MARKETDEPTH_COUNT';
        this.VALUE_THROTLING_PANEL_LIMIT_TIMEANDSALES_COUNT = 'VALUE_THROTLING_PANEL_LIMIT_TIMEANDSALES_COUNT';
        this.VALUE_THROTLING_PANEL_LIMIT_WATCHLIST_COUNT = 'VALUE_THROTLING_PANEL_LIMIT_WATCHLIST_COUNT';
        this.VALUE_THROTLING_PANEL_LIMIT_WATCHLIST_ROWS = 'VALUE_THROTLING_PANEL_LIMIT_WATCHLIST_ROWS';
        this.VALUE_THROTLING_PANEL_LIMIT_SAVEDORDERS_COUNT = 'VALUE_THROTLING_PANEL_LIMIT_SAVEDORDERS_COUNT';
        this.VALUE_THROTLING_PANEL_LIMIT_SAVEDORDERS_ROWS = 'VALUE_THROTLING_PANEL_LIMIT_SAVEDORDERS_ROWS';
        this.VALUE_THROTLING_PANEL_LIMIT_GRID_COUNT = 'VALUE_THROTLING_PANEL_LIMIT_GRID_COUNT';
        this.VALUE_THROTLING_PANEL_LIMIT_OPTIONMASTER_COUNT = 'VALUE_THROTLING_PANEL_LIMIT_OPTIONMASTER_COUNT';
        this.VALUE_PANEL_LIMIT_CHART_TV_COUNT = 'VALUE_PANEL_LIMIT_CHART_TV_COUNT';
        this.FUNCTION_USE_PRODUCT_TYPE = 'FUNCTION_USE_PRODUCT_TYPE';
        this.VALUE_DAILY_PROFIT_TARGET = 'VALUE_DAILY_PROFIT_TARGET';
        this.VALUE_INSTRUMENT_TYPE_LIMIT = 'VALUE_INSTRUMENT_TYPE_LIMIT';
        this.VALUE_QUOTE_HISTORY_DEPTH_LIMITS = 'VALUE_QUOTE_HISTORY_DEPTH_LIMITS';
        this.ALLOW_CHANGE_PASSWORD = 'ALLOW_CHANGE_PASSWORD';
        this.FUNCTION_RESERVER_WITHDRAWAL = 'FUNCTION_RESERVER_WITHDRAWAL';
        this.FUNCTION_PORTFOLIO_MANAGEMENT = 'FUNCTION_PORTFOLIO_MANAGEMENT';
        this.FUNCTION_PIE = 'FUNCTION_PIE';
        this.FUNCTION_DISPLAY_FEES_ON_CONFIRMATIONS = 'FUNCTION_DISPLAY_FEES_ON_CONFIRMATIONS';
        // список POA пользователей для клента
        this.VALUE_POWER_OF_ATTORNEY = 'VALUE_POWER_OF_ATTORNEY';
        /// ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
        this.FUNCTION_ALERTS = 'FUNCTION_ALERTS';
        this.VALUE_RISK_ID = 'VALUE_RISK_ID';
        /// <summary>
        /// not allow close positions manualy, only orders used(for stocks mostly)
        /// </summary>
        // [RulesDecomposer(RulesDecomposer.AllAccounts)]
        this.FUNCTION_CLOSE_POSITIONS_DISABLE = 'FUNCTION_CLOSE_POSITIONS_DISABLE';
        // [RulesDecomposer(RulesDecomposer.MyUser)]
        this.TERMINAL_HTML = 'TERMINAL_HTML';
        /// <summary>
        /// Fifo positions (заведено под интеграции)
        /// </summary>
        // [RulesDecomposer(RulesDecomposer.MyUser)]
        this.FUNCTION_FIFO_POSITIONS = 'FUNCTION_FIFO_POSITIONS';
        // [RulesDecomposer(RulesDecomposer.MyUser)]
        this.FUNCTION_CHART_VOLUME_BARS = 'FUNCTION_CHART_VOLUME_BARS';
        this.FUNCTION_USER_ALLOW_CUSTOM_SLTP_TRIGGER_PRICE = 'FUNCTION_USER_ALLOW_CUSTOM_SLTP_TRIGGER_PRICE'; // #109798
        this.FUNCTION_ALLOW_SLTP_IN_PERCENT = 'FUNCTION_ALLOW_SLTP_IN_PERCENT';
        this.ALLOW_CHANGES_LOGGING = 'ALLOW_CHANGES_LOGGING'; // #111072
        this.FUNCTION_POSITIONSADMIN = 'FUNCTION_POSITIONSADMIN';
        this.FUNCTION_LOCKED_BY_BROKER = 'FUNCTION_LOCKED_BY_BROKER';
        // #endregion
        this.FUNCTION_USE_ONE_TIME_PASSWORD = 'USE_ONE-TIME_PASSWORD';
        this.FUNCTION_PAMM_ACCOUNTS = 'FUNCTION_PAMM_ACCOUNTS';
        this.FUNCTION_SLAVE = 'FUNCTION_SLAVE';
        this.FUNCTION_EXT_RISK = 'FUNCTION_EXT_RISK';
        this.FUNCTION_TRADING_OUT_OF_SESSION = 'FUNCTION_TRADING_OUT_OF_SESSION';
        /// Максимальное количество ордеров в день
        this.VALUE_MAX_DAY_ORDERS = 'VALUE_MAX_DAY_ORDERS';
        // Доступность калькулятора Position Sizing в Order Entry
        this.FUNCTION_POSITION_SIZING = 'FUNCTION_POSITION_SIZING';
        // for Get Snapshot #100287
        this.AVAILABLE_NUMBER_OF_SNAPSHOT_REQUESTS = 'AVAILABLE_NUMBER_OF_SNAPSHOT_REQUESTS';
        this.SNAPSHOT_REQUESTS_LIMIT = 'SNAPSHOT_REQUESTS_LIMIT';
        this.VALUE_MARKET_DATA_SUBSCRIBER_STATUS = 'VALUE_MARKET_DATA_SUBSCRIBER_STATUS';
        /// <summary>
        /// # 103539 Send Trailing stop price
        /// </summary>
        this.FUNCTION_TRAILING_STOP_BY_PRICE = 'FUNCTION_TRAILING_STOP_BY_PRICE';
        /// <summary>
        /// #101641
        /// </summary>
        this.FUNCTION_TRADING_MODE_MODIFICATION = 'FUNCTION_TRADING_MODE_MODIFICATION';
        /// <summary>
        /// #92710
        /// </summary>
        this.VALIDATE_MAX_LOT_CLOSE_ORDER = 'VALIDATE_MAX_LOT_CLOSE_ORDER';
        // #108200 -> https://tp.traderevolution.com/entity/107651
        this.PROTECTIVE_ORDERS = 'PROTECTIVE_ORDERS';
        this.FUNCTION_GAINERS_LOSERS_ALGORITHM = 'FUNCTION_GAINERS_LOSERS_ALGORITHM'; // #118023
        this.FUNCTION_HIGH_LOW_ALGORITHM = 'FUNCTION_HIGH_LOW_ALGORITHM'; // #118026
        this.FUNCTION_NOTIFICATIONS = 'FUNCTION_NOTIFICATIONS'; // #110710 <- #110484
        this.FUNCTION_ORDERS_WITH_NEGATIVE_PRICE = 'FUNCTION_ORDERS_WITH_NEGATIVE_PRICE'; // #109599 поки що не як не використовуємо, додав заради інформативності
        this.FUNCTION_PASSWORD_BLACKLIST_CHECK = 'FUNCTION_PASSWORD_BLACKLIST_CHECK'; // #112524 -> #113076
        this.FUNCTION_VIDEO = 'FUNCTION_VIDEO'; // #114288
        this.FUNCTION_DISPLAY_RESULTS = 'FUNCTION_DISPLAY_RESULTS'; // #112617
        this.FUNCTION_MANAGED_STATISTICS = 'FUNCTION_MANAGED_STATISTICS'; // #112617
        this.FUNCTION_TRADINGVIEW_CHART = 'FUNCTION_CHART_TV'; // #116014
        this.FUNCTION_CLOSE_ACCOUNT = 'FUNCTION_CLOSE_ACCOUNT'; // #116085
        this.ACCOUNT_LINKED_WORKSPACE = 'ACCOUNT_LINKED_WORKSPACE'; // #118235 -> #119101
        this.FUNCTION_STATEMENT_PANEL = 'FUNCTION_STATEMENT_PANEL'; // #119782
        this.USER_SESSION_TIMEOUT = 'USER_SESSION_TIMEOUT';
        this.LEVERAGE_USAGE_WARN = 'LEVERAGE_USAGE_WARN';
        this.FUNCTION_COPY_TRADE = 'FUNCTION_COPY_TRADE'; // #123699
        this.FUNCTION_USE_SPREAD_PLAN_FOR_CROSS_RATES = 'FUNCTION_USE_SPREAD_PLAN_FOR_CROSS_RATES'; // #
        this.FUNCTION_CARE_ORDERS = 'FUNCTION_CARE_ORDERS';
        this.IS_ALLOW_MIDDLE_REQUEST_ON_CHART = 'IS_ALLOW_MIDDLE_REQUEST_ON_CHART'; // Fake rule
        this.CA_LOGIN_CHECK = 'CA_LOGIN_CHECK';
        this.CA_TRADE_CHECK = 'CA_TRADE_CHECK';
        this.FUNCTION_AGGREGATED_PRICE = 'FUNCTION_AGGREGATED_PRICE';
        this.FUNCTION_ALLOW_OTH_TRADING = 'FUNCTION_ALLOW_OTH_TRADING';
        this.AVAILABLE_ORDER_PLACEMENT_WHEN_ROUTE_ACTIVE_AND_NOT_RUNNING = 'AVAILABLE_ORDER_PLACEMENT_WHEN_ROUTE_ACTIVE_AND_NOT_RUNNING';
        this.FUNCTION_WEBHOOKS = 'FUNCTION_WEBHOOKS';
        this.FUNCTION_MOBILE_APPS = 'FUNCTION_MOBILE_APPS';
        this.ALLOW_ADV_CLOSE_MOBILE = 'ALLOW_ADV_CLOSE_MOBILE'; /* #130993 */
    }
}
export const RulesSet = new _RulesSet();
export var RuleType;
(function (RuleType) {
    RuleType[RuleType["User"] = 0] = "User";
    RuleType[RuleType["FeatureFlag"] = 1] = "FeatureFlag";
})(RuleType || (RuleType = {}));
